import { Text } from '@kerfjs/ui/text';
import type { SafeHtml } from 'kerfjs';

import { LabeledSpinner } from '../../../components/labeled-spinner.js';
import { chatLiveActivity, chatLiveText, chatMessages } from '../../../data/state.js';
import { ChatMessageView } from './chat-message-view.js';
import { MessageMarkdown } from './message-markdown.js';

/** Shared production message stream for docked and center chat layouts. */
export function ChatTranscript({ emptyText }: { emptyText: string }): SafeHtml {
  const messages = chatMessages.value;
  const live = chatLiveActivity.value;
  const liveText = chatLiveText.value;
  return (
    <>
      {messages.length === 0 && liveText === '' ? (
        <Text tone="quiet" size="compact">
          {emptyText}
        </Text>
      ) : (
        <ol class="chat-transcript">
          {messages.map((message) => (
            <ChatMessageView message={message} />
          ))}
          {liveText !== '' ? (
            <li class="chat-message-view chat-message-view--assistant chat-message-view--streaming" data-chat-live-text>
              <MessageMarkdown text={liveText} />
            </li>
          ) : null}
        </ol>
      )}
      {live !== '' ? <LabeledSpinner label={live} quiet /> : null}
    </>
  );
}
